<template>
  <div>
    <QueryForm ref="queryFormRef" @query="onQueryAction">
      <el-button @click="onBatchModify(selectionList)">批量修改游戏</el-button>
      <el-button @click="onShowAddTagModal" type="primary">新增营销主题标签</el-button>
    </QueryForm>

    <Viewport v-model="tableHeight">
      <el-table
        v-loading="tableLoading"
        class="common-el-table-styles"
        border
        stripe
        :data="tableData"
        :height="tableHeight"
        @selection-change="onTableSelectionChange"
      >
        <el-table-column type="selection" width="39"> </el-table-column>
        <el-table-column prop="labelId" label="标签ID" width="90"> </el-table-column>
        <el-table-column prop="content" label="标签内容"> </el-table-column>
        <el-table-column prop="relatedMaterialsNum" label="关联素材数" width="120"> </el-table-column>
        <el-table-column prop="gameNames" label="关联游戏" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="createOpName" label="创建人" width="90"> </el-table-column>
        <el-table-column prop="upOpName" label="更新人" width="90"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="240"> </el-table-column>
        <el-table-column prop="upTime" label="更新时间" width="240"> </el-table-column>
        <el-table-column label="操作" width="90">
          <template slot-scope="{ row }">
            <el-button type="text" @click="onTableRowUpdate(row)">修改</el-button>
            <el-button type="text" @click="onTableRowRemove(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination
          :current-page.sync="pager.pageId"
          :page-size.sync="pager.pageSize"
          :total="pager.total"
          :page-sizes="[30, 50, 100, 200]"
          @current-change="getTableData"
          @size-change="onQueryAction"
          layout="total, sizes, prev, pager, next, jumper"
          background
        >
        </el-pagination>
      </div>
    </Viewport>

    <el-dialog
      :title="modalType === FORM_TYPE.ADD ? '新增标签' : '编辑标签'"
      :visible.sync="showTagFormModal"
      :close-on-click-modal="false"
      :show-close="false"
      width="540px"
    >
      <TagForm ref="tagFormRef" :form-type="modalType"> </TagForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseModal">取 消</el-button>
        <el-button type="primary" :loading="onConfirmLoading" @click="onTagFormConfirm(selectionList)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { getTag } from '@/api/manage.model'
import QueryForm from './components/tags/query-form.vue'
import TagForm from './components/tags/tag-form.vue'
import { useTable, useAddUpdateModal } from './hooks/useTags.js'
import { FORM_TYPE, LABEL_TYPES } from './const.js'

const queryFormRef = ref(null)
const labelType = LABEL_TYPES.MARKETING_LABEL
const {
  tableData,
  tableLoading,
  tableHeight,
  pager,
  selectionList,
  onQueryAction,
  getTableData,
  onTableSelectionChange,
  onTableRowRemove
} = useTable(queryFormRef, labelType)
const { modalType, showTagFormModal, tagFormRef, onConfirmLoading, onShowAddTagModal, onBatchModify, onCloseModal, onTagFormConfirm } =
  useAddUpdateModal({ getTableData, labelType })

const onTableRowUpdate = (row) => {
  modalType.value = FORM_TYPE.UPDATE
  getTag({ labelId: row.labelId }).then((data) => {
    if (data) {
      const { labelId, content, gameIds } = data
      showTagFormModal.value = true
      nextTick(() => {
        tagFormRef.value.setForm({
          labelId,
          label: content,
          gameIds: (gameIds?.split(',') || []).map(Number),
          gameGroupId: ''
        })
      })
    }
  })
}

onMounted(onQueryAction)
</script>
<style lang="scss" scoped>
.pager {
  text-align: right;
  padding: 5px 0;
}
</style>
